<template>
    <div class="waiting_room">
        <!-- Diálogo de visualización -->
        <v-dialog v-model="dialogShowDocument" max-width="900px">
            <v-card>
                <v-toolbar flat color="primary" dark>
                <v-toolbar-title>Visualizador de Archivo</v-toolbar-title>
                <v-spacer></v-spacer>

                <!-- Botón Descargar -->
                <!-- <v-btn icon @click="downloadFile" :disabled="!fileUrl">
                    <v-icon>cloud_download</v-icon>
                </v-btn> -->

                <!-- Botón Cerrar -->
                <v-btn icon @click="dialogShowDocument = false">
                    <v-icon>close</v-icon>
                </v-btn>
                </v-toolbar>

                <v-card-text>
                <!-- PDF -->
                <div v-if="isPdf" style="height: 80vh;">
                    <iframe
                    :src="fileUrl"
                    width="100%"
                    height="100%"
                    frameborder="0"
                    ></iframe>
                </div>

                <!-- Imagen -->
                <div v-else style="text-align: center;">
                    <img
                    :src="fileUrl"
                    alt="Imagen"
                    style="max-width: 100%; max-height: 80vh; border-radius: 8px;"
                    />
                </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDocumentos" scrollable max-width="600px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        Documentos Adjuntos
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogDocumentos = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-layout wrap class="text-xs-center">
                        <template v-for="(doc, key) in missingDocumentations">
                        <v-flex xs12 sm6 :key="`preview-${key}`" class="mb-4">
                            <v-card outlined class="pa-3">
                            <div class="font-weight-bold">{{ doc.name }}</div>
                            <div class="text-xs-center my-2">
                                <v-chip
                                    v-if="doc.file"
                                    color="green"
                                    text-color="white"
                                    small
                                >
                                    <v-icon left small>check_circle</v-icon>
                                    Archivo adjunto
                                </v-chip>
                                <v-chip
                                    v-else
                                    color="orange"
                                    text-color="white"
                                    small
                                >
                                    <v-icon left small>warning</v-icon>
                                    Falta documento
                                </v-chip>
                            </div>
                            <div v-if="doc.file" class="caption grey--text text--darken-1 mb-2">
                                <div v-if="doc.valid_until"><strong>Vence:</strong> {{ formatDate(doc.valid_until) }}</div>
                                <div v-if="doc.ocr_confidence"><strong>Confianza:</strong> {{ doc.ocr_confidence }}%</div>
                                <div v-if="doc.file" class="mt-1">{{ doc.is_valid ? '✓ Validado' : '⚠ Pendiente validación' }}</div>
                            </div>
                            <v-btn
                                small
                                color="primary"
                                class="mt-2"
                                @click="openDialog(doc.file)"
                                :disabled="!doc.file"
                            >
                                <v-icon left small>visibility</v-icon>
                                Visualizar
                            </v-btn>
                            </v-card>
                        </v-flex>
                        </template>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogContractor" persistent scrollable max-width="1000px">
            <v-card class="elevation-5 center" :color="data_access_contractor.authorized ? 'blue-grey lighten-4' : 'yellow lighten-2'">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('info_invitation')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogContractor = false, activar_camara = true">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text v-if="Object.keys(info_contractor).length > 0">
                    <v-flex class="text-xs-center" xs12>
                        <h2>{{$t('info_contractor')}}</h2>
                        <br>
                        <v-layout align-center justify-center row wrap>
                            <v-flex class="text-xs-center" xs12 sm6>
                                <v-img
                                        :src="info_contractor.idFront"
                                        position="center center"
                                        class="grey lighten-2"
                                ></v-img>
                            </v-flex>
                            <v-flex class="text-xs-center" xs12 sm6>
                                <table id="datas">
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Visitante')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_contractor.firstName}}
                                                {{ info_contractor.lastName}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <!-- <tr>
                                        <th>
                                            <h2>
                                                {{$t('Area')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.areaName}}
                                            </h2>
                                        </td>
                                    </tr> -->
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('dias_validos')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2 v-if="info_contractor.diary.includes('0') === true">
                                                {{ $t('Lunes') }}
                                            </h2>
                                            <h2 v-if="info_contractor.diary.includes('1') === true">
                                                {{ $t('Martes') }}
                                            </h2>
                                            <h2 v-if="info_contractor.diary.includes('2') === true">
                                                {{ $t('Miercoles') }}
                                            </h2>
                                            <h2 v-if="info_contractor.diary.includes('3') === true">
                                                {{ $t('Jueves') }}
                                            </h2>
                                            <h2 v-if="info_contractor.diary.includes('4') === true">
                                                {{ $t('Viernes') }}
                                            </h2>
                                            <h2 v-if="info_contractor.diary.includes('5') === true">
                                                {{ $t('Sabado') }}
                                            </h2>
                                            <h2 v-if="info_contractor.diary.includes('6') === true">
                                                {{ $t('Domingo') }}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('fecha_inicial')}}
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_contractor.initialDate}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('fecha_expiracion')}}
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_contractor.finalDate}}
                                            </h2>
                                        </td>
                                    </tr>
                                </table>
                                <v-flex xs12>
                                  <v-autocomplete
                                      autofocus
                                      readonly
                                      v-model="id_empleado"
                                      prepend-icon="person"
                                      name="id_empleado"
                                      :item-text="example"
                                      item-value="id"
                                      :label="$t('Empleado')"
                                      :filter="customFilter"
                                      :error-messages="errores.id_empleado"
                                      :items="empleados"
                                      :no-data-text="$t('no_resultados')"
                                  ></v-autocomplete>
                                </v-flex>
                                <v-flex xs12>
                                  <v-autocomplete
                                      readonly
                                      v-model="id_area"
                                      prepend-icon="location_city"
                                      name="id_area"
                                      item-text="nombre"
                                      item-value="id"
                                      :label="$t('Area')"
                                      :filter="customFilterArea"
                                      :error-messages="errores.id_area"
                                      :items="areas"
                                      :no-data-text="$t('no_resultados')"
                                  >
                                  </v-autocomplete>
                                  <v-flex xs12>
                                    <v-text-field
                                        readonly
                                        v-model="empresa"
                                        prepend-icon="business"
                                        name="empresa"
                                        :label="$t('Empresa')"
                                        :error-messages="errores.empresa"
                                    >
                                    </v-text-field>
                                  </v-flex>
                                  <v-flex xs12>
                                    <v-text-field
                                        readonly
                                        v-model="notas"
                                        prepend-icon="notes"
                                        name="notas"
                                        :label="$t('Notas')"
                                        :error-messages="errores.notas"
                                    >
                                    </v-text-field>
                                  </v-flex>
                                </v-flex>
                                <!-- <v-layout align-center justify-center row wrap class="mt-4">
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <v-text-field
                                                outline
                                                v-if="info_invitation.automovil"
                                                v-model="datos_coche"
                                                prepend-icon="directions_car"
                                                name="datos_coche"
                                                :label="$t('datos_coche')"
                                                :error-messages="errores.datos_coche"
                                        >
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                       <v-text-field
                                                outline
                                                type="number"
                                                v-if="info_invitation.health_survey"
                                                v-model="temperature"
                                                prepend-icon="thermostat"
                                                name="temperature"
                                                :label="$t('temperature')"
                                                :error-messages="errores.temperature"
                                        >
                                        </v-text-field>
                                    </v-flex>
                                </v-layout> -->
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-card-text>
                <v-card-actions v-if="entrada" class="justify-center">
                    <v-layout align-center justify-center row wrap>
                        <v-flex v-if="!data_access_contractor.authorized" xs12 class="text-xs-center">
                            <h3>{{$t('attemps')}} : {{data_access_contractor.count_authorized}}/2</h3>
                        </v-flex>
                        <v-flex xs12 class="text-xs-center">
                            <v-btn
                                    large
                                    color="error"
                                    @click="dialogContractor = false, activar_camara = true"
                            >{{ $t('cerrar')}}
                            </v-btn>
                            <v-btn
                                    v-if="data_access_contractor.authorized"
                                    large
                                    color="success"
                                    :loading="loading"
                                    @click="create_access_contractor(data_access_contractor.id), dialog = false, qr_code='', entrada = false, salida = false, sala_espera = false, activar_camara = true"
                            >{{$t('acceso')}}
                            </v-btn>
                            <v-btn
                              v-if="!data_access_contractor.authorized && data_access_contractor.count_authorized !== 0 && countDownAuthorizedAccessContractor === 0 && data_access_contractor.id !== 0"
                              large
                              color="primary"
                              :loading="loading"
                              @click="notificar_anfitrion_acceso_contractor(data_access_contractor.id)"
                            >
                                Notificar al anfitrión <br> autorizar acceso
                            </v-btn>
                            <v-btn
                                    v-if="!data_access_contractor.authorized && data_access_contractor.count_authorized !== 0 && countDownAuthorizedAccessContractor > 0"
                                    large
                                    color="primary"
                            >
                                Disponible en : {{countDownAuthorizedAccessContractor}}
                            </v-btn>
                            <v-btn
                                    v-if="!data_access_contractor.authorized && data_access_contractor.count_authorized === 0"
                                    large
                                    color="success"
                                    :loading="loading"
                                    @click="create_access_contractor(data_access_contractor.id), dialog = false, qr_code='', entrada = false, salida = false, sala_espera = false, activar_camara = true"
                            >{{$t('acceso')}}
                            </v-btn>
                            <v-btn
                                    v-if="!data_access_contractor.authorized && data_access_contractor.count_authorized !== 0 && data_access_contractor.id !== 0"
                                    large
                                    :loading="loadingCountInAccessContractor"
                                    color="primary"
                                    @click="getRecordAccessContracorById(data_access_contractor.id)"
                            >
                                <v-icon>refresh</v-icon>
                            </v-btn>
                            <!-- <v-btn
                                    large
                                    color="error"
                                    @click="showOptions"
                            >
                                <v-icon>block</v-icon>
                                {{$t('deny_access')}}
                            </v-btn> -->
                        </v-flex>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-dialog>
      <!--    Diálogo Opciones   -->
        <v-dialog v-model="dialogReasons" persistent width="400">
            <v-card class="justify-center">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('select_reason')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogReasons = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-flex xs12>
                    <v-radio-group
                            v-model="reasons"
                            prepend-icon="fact_check"
                            name="reasons"
                            :mandatory="false"
                    >
                        <v-radio :label="$t('inappropriate_behavior')" :value="$t('inappropriate_behavior')"></v-radio>
                        <v-radio :label="$t('lack_equipment')" :value="$t('lack_equipment')"></v-radio>
                        <v-radio :label="$t('inconvenient_state_health')" :value="$t('inconvenient_state_health')"></v-radio>
                        <v-radio :label="$t('high_temperature')" :value="$t('high_temperature')"></v-radio>
                        <v-radio :label="$t('inconsistent_false_data')" :value="$t('inconsistent_false_data')"></v-radio>
                    </v-radio-group>
                </v-flex>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-center">
                    <v-btn
                            color="primary"
                            :loading="loading_reason"
                            @click="chooseReason"
                    >
                        {{$t('aceptar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--    Diálogo Persistente para mostrar Errores   -->
        <v-dialog v-model="dialog_errores"
                  persistent
                  width="400"
        >
            <v-card class="justify-center">
                <v-card-title
                        :class="head_color"
                        primary-title
                >
                    {{$t('aviso')}}
                </v-card-title>
                <v-card-text>
<!--                    <h3 class="text-xs-center">{{errores_guard}}</h3>-->
                    <div class="text-xs-center" v-html="errores_guard" />
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-center">
                    <v-btn
                            v-if="band_gafete"
                            color="primary"
                            x-small
                            :loading="loading_gafete"
                            @click="download_gafete"
                    >{{$t('print_name_tag')}}
                    </v-btn>
                    <v-btn
                            v-if="survey"
                            color="primary"
                            x-small
                            @click="dialogShowSurvey = true"
                    >{{$t('answer')}}
                    </v-btn>
                    <v-btn
                            color="primary"
                            @click="dialog_errores = false, errores_guard = '', band_gafete = false, bandAccessNoCode = false"
                    >
                        {{$t('aceptar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--    Diálogo para mostrar encusta COVID al Vigilante y asi pueda contestarla  -->
        <v-dialog v-model="dialogShowSurvey"
                  scrollable
                  persistent
                  width="800"
        >
          <v-card class="justify-center">
            <v-toolbar color="primary" dark>
              <v-icon>masks</v-icon><v-toolbar-title>{{$t('header_survey')}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                  class="align-self-end"
                  color="red"
                  icon
                  @click="dialogShowSurvey = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              {{$t('top1_survey')}}
              <br><br>
              {{$t('top2_survey')}}
              <br>
              <br>
              <v-divider></v-divider>
              <br>
              <v-layout row wrap>
                <v-flex xs12>
                  <div>
                    <strong>{{$t('question1')}}</strong>
                  </div>
                </v-flex>
                <v-flex xs12>
                  <v-radio-group v-model="row1" row>
                    <v-radio small :label="$t('Si')" :value="true"></v-radio>
                    <v-radio label="No" :value="false"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <div>
                    <strong>{{$t('question2')}}</strong>
                  </div>
                </v-flex>
                <v-flex xs12>
                  <v-radio-group v-model="row2" row>
                    <v-radio small :label="$t('Si')" :value="true"></v-radio>
                    <v-radio label="No" :value="false"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <div>
                    <strong>{{$t('question3')}}</strong>
                  </div>
                </v-flex>
                <v-flex xs12>
                  <v-radio-group v-model="row3" row>
                    <v-radio small :label="$t('Si')" :value="true"></v-radio>
                    <v-radio label="No" :value="false"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <div>
                    <strong>{{$t('question4')}}</strong>
                  </div>
                </v-flex>
                <v-flex xs12>
                  <v-radio-group v-model="row4" row>
                    <v-radio small :label="$t('Si')" :value="true"></v-radio>
                    <v-radio label="No" :value="false"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
              <br>
              {{$t('below_survey')}}
              <br><br>
              <strong class="text-xs-centers">{{$t('msg_below_survey')}}</strong><br><br>
              <strong>{{$t('nombre')}}: </strong>{{name}}
              <br>
              <strong>{{$t('Fecha')}}: </strong>{{dd}}/{{mm}}/{{yyyy}}
              <v-divider></v-divider>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="justify-center">
              <v-alert :value="contestado" type="error" class="black--text">
                  {{$t('msg_error_survey')}}
              </v-alert>
              <v-btn v-show="!contestado" @click="send" :loading="loading" block color="primary">{{$t('enviar')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- Diálogo modal Persistente para seleccionar la Caseta -->
        <v-dialog v-model="dialog_inicio" persistent max-width="400px">
            <v-form @submit.prevent="set_caseta()">
                <v-card class="justify-center">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('selecciona_caseta')}}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-autocomplete
                                v-model="caseta"
                                name="caseta"
                                :items="casetas"
                                item-text="nombre"
                                item-value="id"
                                :label="$t('Casetas')"
                        ></v-autocomplete>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn
                                color="primary"
                                type="submit"
                        >{{ $t('aceptar') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <v-dialog v-model="dialog" persistent scrollable max-width="1000px">
            <v-card v-if="entrada" :color="info_invitation.authorized ? 'blue-grey lighten-4' : 'yellow lighten-2'" class="elevation-5 center">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('info_invitation')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialog = false, activar_camara = true">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text v-if="Object.keys(info_invitation).length > 0">
                    <v-flex class="text-xs-center" xs12>
                        <h2>{{$t('info_invitado')}}</h2>
                        <br>
                        <v-layout align-center justify-center row wrap>
                            <v-flex class="text-xs-center" xs12 sm6>
                                <v-img
                                        :src="info_invitation.guest_Avatar"
                                        position="center center"
                                        class="grey lighten-2"
                                ></v-img>
                                <v-btn
                                    color="primary"
                                    class="mt-2"
                                    v-if="info_invitation.documentationByInvitation.length > 0"
                                    :loading="loadingDocumentation"
                                    @click="showDocumentation()"
                                >
                                    Ver Documentos Adjuntos
                                </v-btn>
                            </v-flex>
                            <v-flex class="text-xs-center" xs12 sm6>
                                <table id="datas">
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Visitante')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.guestFirstName}}
                                                {{ info_invitation.guestLastName}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('celular')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.guestCellPhone}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr v-if="info_invitation.guestNameCompany !== null">
                                        <th>
                                            <h2>
                                                {{$t('Empresa')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.guestNameCompany}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Area')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.areaName}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr v-if="info_invitation.secEqu.length > 0">
                                        <th>
                                            <h2>
                                                {{$t('equipo_seguridad')}}
                                            </h2>
                                        </th>
                                        <td>
                                            <h3>

                                                <div v-for="(equipo, index) in info_invitation.secEqu" v-bind:key="equipo.index">
                                                    <h3>{{index + 1}} .- {{ equipo.nameEquipment }}</h3>
                                                </div>
                                            </h3>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Asunto')}}
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.asunto}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('multiple_accesses')}}
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.multiple_accesses ? $t('Si') : 'No'}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr v-if="info_invitation.typeInv == 2">
                                        <th>
                                            <h2>
                                                {{$t('dias_validos')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2 v-if="info_invitation.diary.includes('0') === true">
                                                {{ $t('Lunes') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('1') === true">
                                                {{ $t('Martes') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('2') === true">
                                                {{ $t('Miercoles') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('3') === true">
                                                {{ $t('Jueves') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('4') === true">
                                                {{ $t('Viernes') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('5') === true">
                                                {{ $t('Sabado') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('6') === true">
                                                {{ $t('Domingo') }}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr v-if="info_invitation.typeInv == 2">
                                        <th>
                                            <h2>
                                                {{$t('fecha_expiracion')}}
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.expiration}}
                                            </h2>
                                        </td>
                                    </tr>
                                </table>
                                <v-layout align-center justify-center row wrap class="mt-4">
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <v-text-field
                                                outline
                                                v-if="info_invitation.automovil"
                                                v-model="datos_coche"
                                                prepend-icon="directions_car"
                                                name="datos_coche"
                                                :label="$t('datos_coche')"
                                                :error-messages="errores.datos_coche"
                                        >
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <v-text-field
                                                outline
                                                type="number"
                                                v-if="info_invitation.health_survey"
                                                v-model="temperature"
                                                prepend-icon="thermostat"
                                                name="temperature"
                                                :label="$t('temperature')"
                                                :error-messages="errores.temperature"
                                        >
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-divider :inset="false"></v-divider>
                    <v-flex class="text-xs-center" xs12>
                        <h2>{{$t('info_anfitrion')}}</h2>
                        <br>
                        <v-layout align-center justify-center row wrap>
                            <v-flex class="text-xs-center" xs12 sm6>
                                <v-img
                                        :src="info_invitation.host_avatar"
                                        position="center center"
                                        class="grey lighten-2"
                                ></v-img>
                            </v-flex>
                            <v-flex class="text-xs-center" xs12 sm6>
                                <table id="datas">
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Anfitrion')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.hostFirstName}}
                                                {{ info_invitation.hostLastName}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('celular')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.host_celular}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Area')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.areaName}}
                                            </h2>
                                        </td>
                                    </tr>
                                </table>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-layout align-center justify-center row wrap>
                        <v-flex v-if="!info_invitation.authorized" xs12 class="text-xs-center">
                            <h3>{{$t('attemps')}} : {{info_invitation.count}}/2</h3>
                        </v-flex>
                        <v-flex xs12 class="text-xs-center">
                            <v-btn
                                    large
                                    color="error"
                                    @click="dialog = false, activar_camara = true"
                            >{{ $t('cerrar')}}
                            </v-btn>
                            <v-btn
                                    v-if="info_invitation.authorized && sala_espera"
                                    large
                                    color="success"
                                    :loading="loading"
                                    @click="create_acceso(info_invitation.id), dialog = false, qr_code='', entrada = false, salida = false, sala_espera = false, activar_camara = true"
                            >{{$t('acceso')}}
                            </v-btn>
                            <v-btn
                                    v-if="info_invitation.authorized && !sala_espera"
                                    large
                                    color="success"
                                    :loading="loading"
                                    @click="updateAccessforAccess(data_access[0].id), dialog = false, qr_code='', entrada = false, salida = false, sala_espera = false, activar_camara = true"
                            >{{$t('acceso')}}
                            </v-btn>
                            <v-btn
                                    v-if="!info_invitation.authorized && info_invitation.count !== 0 && countDown === 0"
                                    large
                                    color="primary"
                                    :loading="loading"
                                    @click="notificar_anfitrion_acceso()"
                            >
                                Notificar al anfitrión <br> autorizar acceso
                            </v-btn>
                            <v-btn
                                    v-if="!info_invitation.authorized && info_invitation.count !== 0 && countDown > 0"
                                    large
                                    color="primary"
                            >
                                Disponible en : {{countDown}}
                            </v-btn>
                            <v-btn
                                    v-if="!info_invitation.authorized && info_invitation.count === 0 && sala_espera"
                                    large
                                    color="success"
                                    :loading="loading"
                                    @click="create_acceso(info_invitation.id), dialog = false, qr_code='', entrada = false, salida = false, sala_espera = false, activar_camara = true"
                            >{{$t('acceso')}}
                            </v-btn>
                            <v-btn
                                    v-if="!info_invitation.authorized && info_invitation.count === 0 && !sala_espera"
                                    large
                                    color="success"
                                    :loading="loading"
                                    @click="updateAccessforAccess(data_access[0].id), dialog = false, qr_code='', entrada = false, salida = false, sala_espera = false, activar_camara = true"
                            >{{$t('acceso')}}
                            </v-btn>
                            <v-btn
                                    v-if="!info_invitation.authorized && info_invitation.count !== 0"
                                    large
                                    :loading="loadingCountIn"
                                    color="primary"
                                    @click="updateCountEntrada()"
                            >
                                <v-icon>refresh</v-icon>
                            </v-btn>
                            <v-btn
                                      large
                                      color="error"
                                      @click="showOptions"
                              >
                                  <v-icon>block</v-icon>
                                  {{$t('deny_access')}}
                              </v-btn>
                            <v-btn
                                      v-if="sala_espera"
                                      large
                                      color="primary"
                                      :loading="loading"
                                      @click="enviarSalaEspera(), dialog = false, qr_code='', entrada = false, salida = false, sala_espera = false"
                              >
                                  <v-icon>living</v-icon>
                                  {{$t('send_waiting_room')}}
                              </v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-actions>
            </v-card>
            <v-card v-if="salida" :color="data_access[0].pase_salida ? 'blue-grey lighten-4' : 'red lighten-2'" class="elevation-5 center">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('form_salida')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialog = false, activar_camara = true">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text v-if="Object.keys(info_invitation).length > 0">
                    <v-flex class="text-xs-center" xs12>
                        <h2>{{$t('info_invitado')}}</h2>
                        <br>
                        <v-layout align-center justify-center row wrap>
                            <v-flex class="text-xs-center" xs12 sm6>
                                <v-img
                                        :src="info_invitation.guest_Avatar"
                                        position="center center"
                                        class="grey lighten-2"
                                ></v-img>
                            </v-flex>
                            <v-flex class="text-xs-center" xs12 sm6>
                                <table id="datas">
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Visitante')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.guestFirstName}}
                                                {{ info_invitation.guestLastName}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('celular')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.guestCellPhone}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr v-if="info_invitation.guestNameCompany !== null">
                                        <th>
                                            <h2>
                                                {{$t('Empresa')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.guestNameCompany}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Area')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.areaName}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr v-if="info_invitation.secEqu.length > 0">
                                        <th>
                                            <h2>
                                                {{$t('equipo_seguridad')}}
                                            </h2>
                                        </th>
                                        <td>
                                            <h3>
                                                <div v-for="(equipo, index) in info_invitation.secEqu" v-bind:key="equipo.index">
                                                    <h3>{{index + 1}} .- {{ equipo.nameEquipment }}</h3>
                                                </div>
                                            </h3>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Asunto')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.asunto}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr v-if="info_invitation.typeInv == 2">
                                        <th>
                                            <h2>
                                                {{$t('dias_validos')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2 v-if="info_invitation.diary.includes('0') === true">
                                                {{ $t('Lunes') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('1') === true">
                                                {{ $t('Martes') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('2') === true">
                                                {{ $t('Miercoles') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('3') === true">
                                                {{ $t('Jueves') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('4') === true">
                                                {{ $t('Viernes') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('5') === true">
                                                {{ $t('Sabado') }}
                                            </h2>
                                            <h2 v-if="info_invitation.diary.includes('6') === true">
                                                {{ $t('Domingo') }}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr v-if="info_invitation.typeInv == 2">
                                        <th>
                                            <h2>
                                                {{$t('fecha_expiracion')}}
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.expiration}}
                                            </h2>
                                        </td>
                                    </tr>
                                </table>
                            </v-flex>
                        </v-layout>
<!--                        <v-layout align-center justify-center row wrap class="mt-4">-->
<!--                            <v-flex class="text-xs-center" xs12 sm6>-->
<!--                                <v-text-field-->
<!--                                        v-if="info_invitation.automovil"-->
<!--                                        v-model="datos_coche"-->
<!--                                        prepend-icon="directions_car"-->
<!--                                        name="datos_coche"-->
<!--                                        :label="$t('datos_coche')"-->
<!--                                        :error-messages="errores.datos_coche"-->
<!--                                >-->
<!--                                </v-text-field>-->
<!--                            </v-flex>-->
<!--                            <v-flex class="text-xs-center" xs12 sm6>-->
<!--                                <v-text-field-->
<!--                                        v-if="info_invitation.health_survey"-->
<!--                                        v-model="temperature"-->
<!--                                        type="number"-->
<!--                                        prepend-icon="thermostat"-->
<!--                                        name="temperature"-->
<!--                                        :label="$t('temperature')"-->
<!--                                        :error-messages="errores.temperature"-->
<!--                                >-->
<!--                                </v-text-field>-->
<!--                            </v-flex>-->
<!--                        </v-layout>-->
                        <br>
                    </v-flex>
                    <v-divider :inset="false"></v-divider>
                    <v-flex class="text-xs-center" xs12>
                        <h2>{{$t('info_anfitrion')}}</h2>
                        <br>
                        <v-layout align-center justify-center row wrap>
                            <v-flex class="text-xs-center" xs12 sm6>
                                <v-img
                                        :src="info_invitation.host_avatar"
                                        position="center center"
                                        class="grey lighten-2"
                                ></v-img>
                            </v-flex>
                            <v-flex class="text-xs-center" xs12 sm6>
                                <table id="datas" style="width:100%">
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Anfitrion')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.hostFirstName}}
                                                {{ info_invitation.hostLastName}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>{{$t('celular')}}:</h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.host_celular}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>{{$t('Area')}}:</h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ info_invitation.areaName}}
                                            </h2>
                                        </td>
                                    </tr>
                                </table>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-divider :inset="false"></v-divider>
                    <v-flex class="text-xs-center" xs12>
                        <h2>{{$t('Información de Acceso')}}</h2>
                        <br>
                        <v-layout align-center justify-center row wrap>
                            <v-flex class="text-xs-center" xs12>
                                <table :color="data_access[0].pase_salida ? 'success' : 'error'"  id="datas" style="width:100%">
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Fecha y hora de acceso')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ data_access[0].fecha_hora_acceso}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Fecha y hora de salida')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ data_access[0].fecha_hora_salida ? data_access[0].fecha_hora_salida : "Pendiente" }}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Estado')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{data_access[0].estado == '1' ? "Adentro" : "Afuera"}}
                                            </h2>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h2>
                                                {{$t('Pase de salida')}}:
                                            </h2>
                                        </th>
                                        <td>
                                            <h2>
                                                {{ data_access[0].pase_salida ? "Firmado" : "No Firmado"}}
                                            </h2>
                                        </td>
                                    </tr>
                                </table>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-layout align-center justify-center row wrap>
                        <v-flex v-if="!data_access[0].pase_salida" xs12 class="text-xs-center">
                            <h3>{{$t('attemps')}} : {{data_access[0].count}}/2</h3>
                        </v-flex>
                        <v-flex xs12 class="text-xs-center">
                            <v-btn
                                    large
                                    color="error"
                                    @click="dialog = false, activar_camara = true"
                            >{{ $t('cerrar')}}
                            </v-btn>
                            <v-btn
                                    v-if="data_access[0].pase_salida"
                                    large
                                    color="success"
                                    :loading="loading"
                                    @click="update_acceso(data_access[0].id), activar_camara = true"
                            >{{$t('registrar_salida')}}
                            </v-btn>
                            <v-btn
                                    v-if="!data_access[0].pase_salida && data_access[0].count !== 0 && countDownSign === 0"
                                    large
                                    color="primary"
                                    :loading="loading"
                                    @click="notificar_anfitrion_firmar()"
                            >
                                Notificar al anfitrión <br> firmar pase de salida
                            </v-btn>
                            <v-btn
                                    v-if="!data_access[0].pase_salida && data_access[0].count !== 0 && countDownSign > 0"
                                    large
                                    color="primary"
                            >
                                Disponible en : {{countDownSign}}
                            </v-btn>
                            <v-btn
                                    v-if="!data_access[0].pase_salida && data_access[0].count === 0"
                                    large
                                    color="success"
                                    :loading="loading"
                                    @click="update_acceso(data_access[0].id), activar_camara = true"
                            >{{$t('registrar_salida')}}
                            </v-btn>
                            <v-btn
                                    v-if="!data_access[0].pase_salida && data_access[0].count !== 0"
                                    large
                                    :loading="loadingCount"
                                    color="primary"
                                    @click="updateCount()"
                            >
                                <v-icon>refresh</v-icon>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog scrollable persistent v-model="dialog_accesos_without_code" max-width="1000">
            <v-card :loading="loadingCountInAccessNoCode" v-if="entradaAccessNoCode" :color="dataAccessNoCode.authorized ? 'blue-grey lighten-4' : 'yellow lighten-2'" class="elevation-5">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('info_invitation')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialog_accesos_without_code = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <div class="text-xs-center">
                        <v-layout justify-center class="text-xs-center" row wrap>
                            <v-flex xs12>
                                <h2>{{$t('info_invitado')}}</h2>
                                <br>
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                      <v-img
                                          :src="data_accesos_without_code.url_foto"
                                          position="center center"
                                          class="grey lighten-2"
                                      ></v-img>
                                    </v-flex>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <table id="datas">
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Visitante')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ data_accesos_without_code.nombre}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Empresa')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ data_accesos_without_code.empresa}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Area')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ data_accesos_without_code.areaName}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Notas')}}
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ data_accesos_without_code.notas}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('hora_acceso')}}
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ data_accesos_without_code.f_acceso}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('hora_salida')}}
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ data_accesos_without_code.f_salida ? data_accesos_without_code.f_salida : "Salida no registrada" }}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Anfitrion')}}
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{data_accesos_without_code.host}}
                                                    </h2>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </div>
                  </v-card-text>
                <v-card-actions class="justify-center">
                  <v-layout align-center justify-center row wrap>
                    <v-flex v-if="!dataAccessNoCode.authorized" xs12 class="text-xs-center">
                      <h3>{{$t('attemps')}} : {{dataAccessNoCode.count_authorized}}/2</h3>
                    </v-flex>
                    <v-flex xs12 class="text-xs-center">
                      <v-btn
                          large
                          color="error"
                          @click="dialog_accesos_without_code = false"
                      >{{ $t('cerrar')}}
                      </v-btn>
                      <v-btn
                          v-if="dataAccessNoCode.authorized"
                          large
                          color="success"
                          :loading="loading"
                          @click="create_access_no_code(dataAccessNoCode.id), dialog_accesos_without_code = false, entradaAccessNoCode = false, salidaAccessNoCode = false"
                      >{{$t('acceso')}}
                      </v-btn>
                      <v-btn
                          v-if="!dataAccessNoCode.authorized && dataAccessNoCode.count_authorized !== 0 && countDownAuthorizedAccessNoCode === 0"
                          large
                          color="primary"
                          :loading="loading"
                          @click="notificar_anfitrion_acceso_sin_codigo(dataAccessNoCode.id)"
                      >
                        Notificar al anfitrión <br> autorizar acceso
                      </v-btn>
                      <v-btn
                          v-if="!dataAccessNoCode.authorized && dataAccessNoCode.count_authorized !== 0 && countDownAuthorizedAccessNoCode > 0"
                          large
                          color="primary"
                      >
                        Disponible en : {{countDownAuthorizedAccessNoCode}}
                      </v-btn>
                      <v-btn
                          v-if="!dataAccessNoCode.authorized && dataAccessNoCode.count_authorized === 0"
                          large
                          color="success"
                          :loading="loading"
                          @click="create_access_no_code(dataAccessNoCode.id), dialog_accesos_without_code = false, entradaAccessNoCode = false, salidaAccessNoCode = false"
                      >{{$t('acceso')}}
                      </v-btn>
                      <v-btn
                          v-if="!dataAccessNoCode.authorized && dataAccessNoCode.count_authorized !== 0"
                          large
                          :loading="loadingCountInAccessNoCode"
                          color="primary"
                          @click="getRecordAccessNoCodeById(dataAccessNoCode.id)"
                      >
                        <v-icon>refresh</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-card-actions>
            </v-card>
            <v-card :loading="loadingCountInAccessNoCode" v-if="salidaAccessNoCode" :color="dataAccessNoCode.pase_salida ? 'blue-grey lighten-4' : 'red lighten-2'" class="elevation-5">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{$t('info_invitation')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialog_accesos_without_code = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <div class="text-xs-center">
                        <v-layout justify-center class="text-xs-center" row wrap>
                            <v-flex xs12>
                                <h2>{{$t('info_invitado')}}</h2>
                                <br>
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                      <v-img
                                          :src="data_accesos_without_code.url_foto"
                                          position="center center"
                                          class="grey lighten-2"
                                      ></v-img>
                                    </v-flex>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <table id="datas">
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Visitante')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ data_accesos_without_code.nombre}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Empresa')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ data_accesos_without_code.empresa}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Area')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ data_accesos_without_code.areaName}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Notas')}}
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ data_accesos_without_code.notas}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('hora_acceso')}}
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ data_accesos_without_code.f_acceso}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('hora_salida')}}
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ data_accesos_without_code.f_salida ? data_accesos_without_code.f_salida : "Salida no registrada" }}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Anfitrion')}}
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{data_accesos_without_code.host}}
                                                    </h2>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-card-text>
                <v-card-actions class="justify-center">
                  <v-layout align-center justify-center row wrap>
                    <v-flex v-if="!dataAccessNoCode.pase_salida" xs12 class="text-xs-center">
                      <h3>{{$t('attemps')}} : {{dataAccessNoCode.count_pase_salida}}/2</h3>
                    </v-flex>
                    <v-flex xs12 class="text-xs-center">
                      <v-btn
                          large
                          color="error"
                          @click="dialog_accesos_without_code = false"
                      >{{ $t('cerrar')}}
                      </v-btn>
                      <v-btn
                          v-if="dataAccessNoCode.pase_salida"
                          large
                          color="success"
                          :loading="loading"
                          @click="create_check_out_access_no_code(dataAccessNoCode.id), dialog_accesos_without_code = false, entradaAccessNoCode = false, salidaAccessNoCode = false"
                      >{{$t('registrar_salida')}}
                      </v-btn>
                      <v-btn
                          v-if="!dataAccessNoCode.pase_salida && dataAccessNoCode.count_pase_salida !== 0 && countDownSign === 0"
                          large
                          color="primary"
                          :loading="loading"
                          @click="notificar_anfitrion_firmar(dataAccessNoCode.id)"
                      >
                        Notificar al anfitrión <br> firmar pase de salida
                      </v-btn>
                      <v-btn
                              v-if="!dataAccessNoCode.pase_salida && dataAccessNoCode.count_pase_salida !== 0 && countDownSign > 0"
                              large
                              color="primary"
                      >
                          Disponible en : {{countDownSign}}
                      </v-btn>
                      <v-btn
                          v-if="!dataAccessNoCode.pase_salida && dataAccessNoCode.count_pase_salida === 0"
                          large
                          color="success"
                          :loading="loading"
                          @click="create_check_out_access_no_code(dataAccessNoCode.id), dialog_accesos_without_code = false, entradaAccessNoCode = false, salidaAccessNoCode = false"
                      >{{$t('registrar_salida')}}
                      </v-btn>
                      <v-btn
                          v-if="!dataAccessNoCode.pase_salida && dataAccessNoCode.count_pase_salida !== 0"
                          large
                          :loading="loadingCountInAccessNoCode"
                          color="primary"
                          @click="getRecordAccessNoCodeById(dataAccessNoCode.id)"
                      >
                        <v-icon>refresh</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogElimnar" max-width="290">
            <v-card>
                <v-card-title class="headline">
                    {{$t('msg_eliminar_sala_espera')}}
                </v-card-title>

                <v-card-text>
                    {{$t('msg_eliminar_invitacion_2')}}
                </v-card-text>

                <v-card-actions>
                    <v-btn
                            color="primary"
                            @click="dialogElimnar = false"
                    >
                        No
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            @click="deleteWaitingRoom()"
                    >
                        {{$t('Si')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-container class="my-1">
            <v-card class="my-2">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('waiting_room')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                    <v-layout class="my-4" align-center justify-center fill-height>
                        <v-flex >
                            <v-data-table
                                    :headers="headers"
                                    :loading="loading_data_accesos_without_code"
                                    :items="accesos_without_code"
                                    :rows-per-page-text="$t('filas_por_pagina')"
                                    :rows-per-page-items="[
                                        {text: '5', value: 5},
                                        {text: '10', value: 10},
                                        {text: '25', value: 25},
                                        {text: this.$t('todos'), value: -1}
                                    ]"
                                    class="elevation-1"
                                    :no-data-text="$t('no_records_waiting_room')"
                            >
                                <template v-slot:items="props">
                                    <td class="justify-center layout px-0">
                                        <v-btn
                                                color="primary"
                                                class="mr-2"
                                                @click="props.item.isShipment ? copyToClipBoard(props.item.qr_code) : (props.item.access_qr_code === true ? copyToClipBoard(props.item.qr_code) : fill_fields(props.item))"
                                                :loading="loading"
                                        >
                                            {{$t('acceso')}}
                                        </v-btn>
                                        <v-btn
                                                color="error"
                                                class="mr-2"
                                                @click="llanaDatosPrelimnar(props.item.access_qr_code, props.item.id, props.item)"
                                                :loading="loading"
                                        >
                                            {{$t('eliminar')}}
                                        </v-btn>
                                    </td>
                                    <td class="text-xs-center">
                                        <v-chip v-if="props.item.isShipment" color="info" outline small label class="font-weight-bold">
                                            Embarque
                                        </v-chip>
                                        <v-chip v-else color="grey" outline small label class="font-weight-bold">
                                            Invitación
                                        </v-chip>
                                    </td>
                                    <td>{{ props.item.guest_full_name }}</td>
                                    <td>{{ props.item.datetime_arrival }}</td>
                                    <td>{{ $t('pendiente') }}</td>
                                    <td>{{ props.item.host_full_name }}</td>
                                </template>
                                <template v-slot:pageText="props">
                                    {{props.rowsPerPage}}
                                    {{$t('Accesos')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-container>
        <!-- Modal for Shipments -->
        <AccessShipmentsModal v-if="showShipmentModal" :qr_code="selectedShipmentQr" ref="shipmentModal" @close="showShipmentModal = false; get_access_without_code_by_date()" />
    </div>
</template>

<script>
    import '@/plugins/axios'
    import store from '@/store'
    import { mapState, mapGetters } from 'vuex'
    import jsPDF from 'jspdf'
    import AccessShipmentsModal from '@/components/vigilante/AccessShipmentsModal.vue'

    export default {
        name: "waiting_room",
        components: {
            AccessShipmentsModal
        },
        data: () => ({
            showShipmentModal: false,
            selectedShipmentQr: '',
            headers: [],
            accesos_without_code: [],
            loading_data_accesos_without_code: false,
            qr_code: '',
            error: '',
            info_invitation: [],
            info_contractor: [],
            dialog: false,
            dialogContractor: false,
            valido: false,
            id_vigilante: 0,
            salida: false,
            entrada: false,
            salidaAccessNoCode: false,
            entradaAccessNoCode: false,
            sala_espera: false,
            estado: '',
            motivo_no_firma: '',
            comentarios_VE: '',
            errores: [],
            datos_coche: '',
            equipo_por_invitacion: [],
            data_access: [],
            dialog_inicio: false,
            casetas: [],
            caseta: 0,
            loading_gafete: false,
            dialog_errores: false,
            errores_guard: '',
            head_color: '',
            band_gafete: false,
            dialogIP: false,
            ip: '127.0.0.1',
            loading: false,
            loadingCount: false,
            loadingCountIn: false,
            dialogReasons: false,
            reasons: null,
            temperature: 0,
            loading_reason: false,
            row1: false,
            row2: false,
            row3: false,
            row4: false,
            dd: null,
            mm: null,
            yyyy: null,
            contestado: false,
            name: '',
            dialogShowSurvey: false,
            survey: false,
            countDown: 0,
            countDownSign: 0,
            dataAccessNoCode: {},
            countDownAuthorizedAccessNoCode: 0,
            countDownAuthorizedAccessContractor: 0,
            loadingCountInAccessNoCode: false,
            loadingCountInAccessContractor: false,
            dialog_accesos_without_code: false,
            bandAccessNoCode: false,
            data_access_contractor: {
                'id': 0,
                'host': '',
                'guest': '',
                'url_foto': '',
                'authorized': false,
                'pase_salida': false,
                'count_authorized': 2,
                'count_pase_salida': 2,
                'estado': -1,
                'notas': '',
                'empresa': '',
                'f_acceso': '',
                'company_logo': '',
                'areaName': ''
            },
            areas: [],
            empleados: [],
            id_empleado: '',
            id_area: '',
            empresa: '',
            notas: '',
            idUserByInvitation: 0,
            dialogElimnar: false,
            idElimniar: 0,
            itemEliminar: null,
            dialogDocumentos: false,
            dialogShowDocument: false,
            fileUrl: '',
            isPdf: false,
            missingDocumentations: [],
            loadingDocumentation: false,
            ineFront: {
                "id": 1000,
                "name": "INE Frente",
                "file": "https://intrare-empresa-test.s3.amazonaws.com/media/Documentation/%2B528887773233/picture.jpeg"
            },
            ineBack: {
                "id": 1001,
                "name": "INE Reverso",
                "file": "https://intrare-empresa-test.s3.amazonaws.com/media/Documentation/%2B528887773233/picture.jpeg"
            },
        }),
        created: function(){
            this.getUsersCompany()
            this.get_areas()
            this.get_current_date()
            this.get_access_without_code_by_date()
            this.get_casetas()
            if(!this.getProfile.enable_parking && localStorage.getItem('id_caseta') === null){
            this.dialog_inicio = true
            }
            if(localStorage.getItem('dirIP') === null){
                this.ip = "127.0.0.1"
            } else {
                this.ip = localStorage.getItem('dirIP')
            }
        },
        watch: {
          row1 (value) {
            this.contestado = value || this.row2 || this.row3 || this.row4
          },
          row2 (value) {
            this.contestado = this.row1 || value || this.row3 || this.row4
          },
          row3 (value) {
            this.contestado = this.row1 || this.row2 || value || this.row4
          },
          row4 (value) {
            this.contestado = this.row1 || this.row2 || this.row3 || value
          }
        },
        computed: {
            ...mapGetters(['getProfile']),
            ...mapState(['caseta_vigilante'])
        },
        beforeUpdate() {
            this.headers = [
                {
                    text: this.$t('acciones'),
                    align: 'center',
                    sortable: false,
                    value: 'details'
                },
                {
                    text: 'Tipo',
                    align: 'center',
                    sortable: true,
                    value: 'isShipment'
                },
                {
                    text: this.$t('Visitante'),
                    align: 'left',
                    sortable: true,
                    value: 'guest_full_name'
                },
                {
                    text: this.$t('hora_llegada'),
                    align: 'left',
                    sortable: true,
                    value: 'datetime_arrival'
                },
                {
                    text: this.$t('hora_acceso'),
                    align: 'left',
                    sortable: true,
                    value: 'datetime_checkin'
                },
                {
                    text: this.$t('Anfitrion'),
                    align: 'left',
                    sortable: true,
                    value: 'host_full_name'
                }
            ]
        },
        methods:{
            openDialog(fileUrl) {
                // 🔧 Ajusta esta ruta a tu estructura de archivos
                this.isPdf = fileUrl.toLowerCase().endsWith('.pdf')
                this.fileUrl = fileUrl
                this.dialogShowDocument = true
            },
            showDocumentation() {
                this.loadingDocumentation = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/get-documents-by-user/' + this.info_invitation.idUserGuest + '/',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                };
                axios(config)
                    .then(response => {
                        console.log(response.data)
                        this.missingDocumentations = this.compareDocumentation(this.info_invitation.documentationByInvitation, response.data)
                        this.loadingDocumentation = false
                    })
                    .catch(error => {
                        this.loadingDocumentation = false
                        console.log(error)
                    })
            },
            formatDate(dateString) {
                if (!dateString) return ''
                return new Date(dateString).toLocaleDateString()
            },
            compareDocumentation(documentationsByInvitation, documentationsByUser) {
                console.log('Empieza a comparar documentaciones')
                let missingDocumentations = []
                // Compare the two sets of documentation
                for(let i = 0; i < documentationsByInvitation.length; i++) {
                    let band = false
                    for(let j = 0; j < documentationsByUser.length; j++) {
                        if(documentationsByInvitation[i].idDocumentation === documentationsByUser[j].idDocumentation.id) {
                            band = true
                            missingDocumentations.push({
                                id: documentationsByUser[j].id,
                                idDocumentation: documentationsByUser[j].idDocumentation,
                                name: documentationsByUser[j].idDocumentation.name,
                                file: documentationsByUser[j].file,
                                is_valid: documentationsByUser[j].is_valid,
                                is_company_document: documentationsByUser[j].idDocumentation.is_company_document,
                                ocr_confidence: documentationsByUser[j].ocr_confidence,
                                extracted_data: documentationsByUser[j].extracted_data,
                                valid_until: documentationsByUser[j].valid_until,
                                uploaded_at: documentationsByUser[j].uploaded_at
                            })
                        }
                    }
                    if(!band) {
                        missingDocumentations.push({
                            id: null,
                            idDocumentation: { id: documentationsByInvitation[i].idDocumentation, name: documentationsByInvitation[i].name },
                            name: documentationsByInvitation[i].name,
                            file: null,
                            is_valid: false,
                            is_company_document: documentationsByInvitation[i].is_company_document,
                            ocr_confidence: null,
                            extracted_data: null,
                            valid_until: null,
                            uploaded_at: null
                        })
                    }
                }
                this.ineFront.file = this.info_invitation.guest_ine_frente
                this.ineBack.file = this.info_invitation.guest_ine_atras
                missingDocumentations.push(this.ineFront)
                missingDocumentations.push(this.ineBack)
                console.log('missingDocumentations = ', missingDocumentations)
                this.dialogDocumentos = true
                return missingDocumentations
            },
            llanaDatosPrelimnar (conCodigo, id, item = null) {
                this.conCodigo = conCodigo
                this.idElimniar = id
                this.itemEliminar = item
                console.log('Con codigo = ', this.conCodigo)
                console.log('Registro a eliminar con ID = ', this.idElimniar)
                this.dialogElimnar = true
            },
            deleteWaitingRoom() {
                console.log('Eliminando registro con ID = ', this.idElimniar)
                let config = null;

                if (this.itemEliminar && this.itemEliminar.isShipment) {
                    config = {
                        method: 'post',
                        url: 'https://empresa-service.intrare.app/shipments/guard/waiting-room/release/',
                        headers: {
                            'Content-Type': 'application/json',
                            'authorization': 'Token ' + store.getters.getToken
                        },
                        data: {
                            qr_code: this.itemEliminar.qr_code,
                            cancel: true
                        }
                    };
                } else {
                    config = {
                        method: 'delete',
                        url: this.conCodigo ? 'https://empresa-service.intrare.app/empresas/accesos/delete/{idAccess}/'.replace('{idAccess}', this.idElimniar) : 'https://empresa-service.intrare.app/bitacora/{idBitacora}/delete/'.replace('{idBitacora}', this.idElimniar),
                        headers: {
                            'Content-Type': 'application/json',
                            'authorization': 'Token ' + store.getters.getToken
                        }
                    };
                }

                axios(config)
                    .then(response => {
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_color', 'warning')
                        this.$store.commit('snackbar_change_message', this.$t('msg_record_deleted'))
                        this.dialogElimnar = false
                        this.get_access_without_code_by_date()
                        setTimeout(this.clear, 3000);
                    })
                    .catch(error => {
                        console.log(error)
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_color', 'error')
                        this.$store.commit('snackbar_change_message', error.response && error.response.data && error.response.data.error ? error.response.data.error : 'Ocurrió un error')
                        setTimeout(this.clear, 3000);
                    })
            },
            getUsersCompany: function(){
            const config = {
                method: 'get',
                url: 'https://empresa-service.intrare.app/empresas/usuarios/',
                headers: {
                'Content-Type': 'application/json',
                'authorization': 'Token ' + store.getters.getToken
                }
            };
            axios(config)
                .then(response => {
                    this.empleados = response.data
                    console.log(this.empleados)
                })
                .catch(error => {
                    console.log(error)
                })

            },
            get_areas: function(){
            const config = {
                method: 'get',
                url: 'https://empresa-service.intrare.app/empresas/areas/',
                headers: {
                'Content-Type': 'application/json',
                'authorization': 'Token ' + store.getters.getToken
                }
            };
            axios(config)
                .then(response => {
                    this.areas = response.data

                    console.log(this.id_empresa)
                })
                .catch(error => {
                    console.log(error)
                })
            },
            countDownTimer() {
                if(this.countDown > 0) {
                    setTimeout(() => {
                        this.countDown -= 1
                        this.countDownTimer()
                    }, 1000)
                }
            },
            countDownSignTimer() {
                if(this.countDownSign > 0) {
                    setTimeout(() => {
                        this.countDownSign -= 1
                        this.countDownSignTimer()
                    }, 1000)
                }
            },
            get_current_date () {
              var today = new Date()
              var dd = today.getDate()
              var mm = today.getMonth() + 1
              var yyyy = today.getFullYear()

              if (dd < 10) {
                dd = '0' + dd
              }
              if (mm < 10) {
                mm = '0' + mm
              }
              today = mm + '/' + dd + '/' + yyyy
              this.dd = dd
              this.mm = mm
              this.yyyy = yyyy
              return today
            },
            get_casetas: function(){
                this.$store.dispatch('security/FETCH_MY_CASETAS', store.getters.getToken)
                    .then(response => {
                        // Manejar múltiples formatos de respuesta
                        if (response && response.casetas && Array.isArray(response.casetas)) {
                            this.casetas = response.casetas
                        } else if (Array.isArray(response)) {
                            this.casetas = response
                        } else if (response && response.data && Array.isArray(response.data)) {
                            this.casetas = response.data
                        }
                        if (this.getProfile.enable_parking && localStorage.getItem('id_caseta') === null) {
                            const casetasActivas = this.casetas.filter(c => c.activa)
                            if (casetasActivas.length === 1) {
                                const casetaId = casetasActivas[0].id
                                localStorage.setItem('id_caseta', casetaId)
                                this.caseta = casetaId
                                this.dialog_inicio = false
                                this.$store.commit('snackbar_activate_true')
                                this.$store.commit('snackbar_change_color', 'success')
                                this.$store.commit('snackbar_change_message', 'Caseta seleccionada correctamente')
                            }
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            set_caseta: function(){
                if(this.caseta > 0){
                    localStorage.setItem('id_caseta', this.caseta)
                    this.dialog_inicio = false
                }
            },
            get_access_without_code_by_date: function () {
                this.loading_data_accesos_without_code = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/getAccessByDateUnionOnlyStatusWaitingRoom/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.accesos_without_code = response.data
                        if (this.getProfile && this.getProfile.enable_shipments) {
                            this.get_shipments_waiting_room();
                        } else {
                            this.loading_data_accesos_without_code = false
                        }
                    })
                    .catch(error => {
                        this.loading_data_accesos_without_code = false
                        console.log(error)
                    })

            },
            get_shipments_waiting_room: function() {
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/shipments/guard/active-invitations/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        if (response.status !== 204 && response.data) {
                            const shipmentItems = response.data
                                .filter(item => item.window_status === 'SALA_ESPERA')
                                .map(item => ({
                                    ...item,
                                    guest_full_name: `${item.guest_first_name || item.client_name} ${item.guest_last_name || ''}`.trim(),
                                    datetime_arrival: item.datetime_arrival || `${item.window_date} ${item.window_time}`,
                                    datetime_checkin: item.datetime_checkin || '',
                                    host_full_name: `${item.host_first_name || ''} ${item.host_last_name || ''}`.trim(),
                                    isShipment: true
                                }));
                            this.accesos_without_code = [...this.accesos_without_code, ...shipmentItems];
                        }
                        this.loading_data_accesos_without_code = false;
                    })
                    .catch(error => {
                        this.loading_data_accesos_without_code = false;
                        console.log("Error fetch shipments in waiting room:", error);
                    });
            },
            copyToClipBoard: function(qrcode) {
                this.qr_code = qrcode
                if (qrcode && qrcode.startsWith('spmt_')) {
                    this.selectedShipmentQr = qrcode;
                    this.showShipmentModal = true;
                    // Need a short timeout for the ref to be available
                    setTimeout(() => {
                        if (this.$refs.shipmentModal) {
                            this.$refs.shipmentModal.qr_code = qrcode;
                        }
                    }, 50);
                    return;
                }
                
                this.loading = true
                if (qrcode.length === 28) {
                    const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/get_contractor/guard/' + qrcode + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                    };
                    axios(config)
                        .then(response => {
                        this.loading = false
                        this.info_contractor = response.data
                        this.valido = true
                        console.log("Valido")
                        // this.dialogContractor = true
                        this.is_access_contractor_in_out_both()
                        })
                        .catch(error => {
                        this.loading = false
                        console.log(error.request.status)
                        switch (error.request.status) {
                            case 404:
                            this.valido = false
                            console.log("No Valido")
                            this.clear_without_activate_camera()
                            this.errores_guard =this.$t('mensaje_qr_no_valido')
                            this.head_color = 'red display-1 text--primary justify-center'
                            this.dialog_errores = true
                            break;
                            case 401:
                            this.valido = false
                            this.clear_without_activate_camera()
                            this.errores_guard = error.response.data.error
                            this.head_color = 'red display-1 text--primary justify-center'
                            this.dialog_errores = true
                            break;
                        }
                        })
                } else {
                    const config = {
                        method: 'get',
                        url: 'https://empresa-service.intrare.app/get_inv/gaurd/' + qrcode + '/',
                        headers: {
                            'Content-Type': 'application/json',
                            'authorization': 'Token ' + store.getters.getToken
                        }
                    }
                    axios(config)
                        .then(response => {
                            this.loading = false
                            this.info_invitation = response.data
                            this.valido = true
                            console.log("Valido")
                            this.is_access_in_out_both()
                        })
                        .catch(error => {
                            this.loading = false
                            console.log(error.request.status)
                            switch (error.request.status) {
                            case 404:
                                this.valido = false
                                console.log("No Valido")
                                this.clear_without_activate_camera()
                                this.errores_guard =this.$t('mensaje_qr_no_valido')
                                this.head_color = 'red display-1 text--primary justify-center'
                                this.dialog_errores = true
                            break;
                            case 401:
                                this.valido = false
                                this.clear_without_activate_camera()
                                this.errores_guard =this.$t('mensaje_qr_no_empresa')
                                this.head_color = 'red display-1 text--primary justify-center'
                                this.dialog_errores = true
                            break;
                            case 423:
                                this.valido = false
                                this.clear_without_activate_camera()
                                this.errores_guard =this.$t('mensaje_qr_no_confirmado')
                                this.head_color = 'red display-1 text--primary justify-center'
                                this.dialog_errores = true
                            break;
                            case 406:
                                this.valido = false
                                this.clear_without_activate_camera()
                                this.errores_guard =this.$t('msg_canceled_invitation')
                                this.head_color = 'red display-1 text--primary justify-center'
                                this.dialog_errores = true
                            break;
                            case 409:
                                this.valido = false
                                this.clear_without_activate_camera2()
                                console.log(JSON.parse(error.request.response).status)
                                if (JSON.parse(error.request.response).status === 0) {
                                this.errores_guard =
                                    `
                                        <h4>${this.$t('msg_survey00')}</h4>
                                        <br><br>
                                        <h5>${this.$t('msg_survey')}</h5>
                                    `
                                }
                                if (JSON.parse(error.request.response).status === 1) {
                                this.errores_guard =
                                    `
                                        <h4>
                                            ${this.$t('msg_survey01')}
                                        </h4>
                                    `
                                this.name = JSON.parse(error.request.response).name
                                this.survey = true
                                this.idUserByInvitation = JSON.parse(error.request.response).idUserByInvitation
                                }
                                this.head_color = 'primary display-1 white--text justify-center'
                                this.dialog_errores = true
                            break;
                            case 403:
                                this.valido = false
                                this.clear_without_activate_camera()
                                console.log(JSON.parse(error.request.response).tipo)
                                let mensaje = JSON.parse(error.request.response).motivo
                                if (JSON.parse(error.request.response).tipo === 1) {
                                this.errores_guard = `<h3 class="text-xs-center"> ${this.$t('mensaje_qr_vetado')} </h3><br><h4>${this.$t('reason2')} ${mensaje}</h4><br><br><h5>${this.$t('msg_veto00')}</h5>`
                                }
                                else {
                                this.errores_guard = `<h3 class="text-xs-center"> ${this.$t('mensaje_qr_vetado')} </h3><br><h4>${this.$t('reason2')} ${mensaje}</h4><br><br><h5>${this.$t('msg_veto00')}</h5>`
                                }
                                this.head_color = 'red display-1 text--primary justify-center'
                                this.dialog_errores = true
                            break;
                            }
                        })
                }
            },
            getRecordAccessNoCodeById(id) {
              this.loadingCountInAccessNoCode = true
              const config = {
                method: 'get',
                url: 'https://empresa-service.intrare.app/bitacora/' + id,
                headers: {
                  'Content-Type': 'application/json',
                  'Accept-Language': this.language,
                },
              };
              axios(config)
                  .then(ok => {
                    this.loadingCountInAccessNoCode = false
                    this.dataAccessNoCode = ok.data[0]
                    if (this.dataAccessNoCode.estado === 0 || this.dataAccessNoCode.estado === 5) {
                      this.entradaAccessNoCode = true
                      this.salidaAccessNoCode = false
                    } else {
                      this.entradaAccessNoCode = false
                      this.salidaAccessNoCode = true
                    }
                  })
                  .catch(error => {
                    this.loadingCountInAccessNoCode = false
                    console.log(error)
                  })
            },
            getRecordAccessNoCodeByIdLoading(id) {
              this.loadingCountInAccessNoCode = true
              const config = {
                method: 'get',
                url: 'https://empresa-service.intrare.app/bitacora/' + id,
                headers: {
                  'Content-Type': 'application/json',
                  'Accept-Language': this.language,
                },
              };
              axios(config)
                  .then(ok => {
                    this.loadingCountInAccessNoCode = false
                    this.dataAccessNoCode = ok.data[0]
                    if (this.dataAccessNoCode.estado === 0 || this.dataAccessNoCode.estado === 5) {
                      this.entradaAccessNoCode = true
                      this.salidaAccessNoCode = false
                    } else {
                      this.entradaAccessNoCode = false
                      this.salidaAccessNoCode = true
                    }
                    this.data_accesos_without_code = this.dataAccessNoCode
                    this.dialog_accesos_without_code = true
                    console.log(this.data_accesos_without_code)
                  })
                  .catch(error => {
                    this.loadingCountInAccessNoCode = false
                    console.log(error)
                  })
            },
            fill_fields: function(item){
                this.getRecordAccessNoCodeByIdLoading(item.id)
            },
            notificar_anfitrion_acceso_sin_codigo(id){
              this.loading = true
              console.log('Avisar al Anfitrión que autorize el acceso sin codigo dela persona = ', id)
              const config = {
                method: 'get',
                url: 'https://empresa-service.intrare.app/notifyAuthorizedAccessNoCode/' + id + '/',
                headers: {
                  'Content-Type': 'application/json',
                }
              };
              axios(config)
                  .then(response => {
                    this.loading = false
                    this.countDownAuthorizedAccessNoCode = 30
                    this.countDownTimerAccessNoCode(id)
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_color', 'success')
                    this.$store.commit('snackbar_change_message', this.$t('msg_notificacion_anfitrion'))
                    setTimeout(this.clear2, 3000)
                  })
                  .catch(error => {
                    this.loading = false
                    console.log(error)
                  })
            },
            countDownTimerAccessContractor(id) {
                if(this.countDownAuthorizedAccessContractor > 0) {
                    setTimeout(() => {
                        this.countDownAuthorizedAccessContractor -= 1
                        this.countDownTimerAccessContractor(id)
                    }, 1000)
                } else {
                    const config2 = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/contractor_access/' + id,
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language,
                    },
                    };
                    axios(config2)
                        .then(ok => {
                        if (ok.data.length > 0) {
                            this.data_access_contractor = ok.data[0]
                        }
                        console.log('Datos devueltos por Servidor DESPUES DE NOTIFICAR POR SEGUNDA OCASION AL ANFITRION')
                        console.log(this.data_access_contractor)
                        console.log('Id = ', this.data_access_contractor.id)
                        })
                        .catch(error => {
                        console.log(error)
                        })
                }
            },
            countDownTimerAccessNoCode(id) {
              if(this.countDownAuthorizedAccessNoCode > 0) {
                setTimeout(() => {
                  this.countDownAuthorizedAccessNoCode -= 1
                  this.countDownTimerAccessNoCode(id)
                }, 1000)
              } else {
                const config2 = {
                  method: 'get',
                  url: 'https://empresa-service.intrare.app/bitacora/' + id,
                  headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': this.language,
                  },
                };
                axios(config2)
                    .then(ok => {
                      this.dataAccessNoCode = ok.data[0]
                      console.log('Datos devueltos por Servidor DESPUES DE NOTIFICAR POR SEGUNDA OCASION AL ANFITRION')
                      console.log(this.dataAccessNoCode)
                      console.log('Id = ', this.dataAccessNoCode.id)
                    })
                    .catch(error => {
                      console.log(error)
                    })
              }
            },
            create_access_no_code (id) {
                this.loading = true
                const config = {
                    method: 'patch',
                    url: 'https://empresa-service.intrare.app/update_access_no_code/' + id + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data:{
                      id_guardhouse_checkin: localStorage.getItem('id_caseta')
                    }
                }
                axios(config)
                    .then(response => {
                        this.loading = false
                        this.errores_guard =this.$t('mensaje_alta_acceso_in')
                        this.head_color = 'green display-1 text--primary'
                        this.band_gafete = true
                        this.dialog_errores = true
                        this.bandAccessNoCode = true
                        this.getRecordAccessNoCodeById(id)
                        this.get_access_without_code_by_date()
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error.response.data)
                        this.head_color = 'red display-1 text--primary'
                        this.errores_guard = error.response.data.error
                        this.dialog_errores = true
                    })
            },
            create_access_contractor (id) {
                this.loading = true
                const config = {
                    method: 'patch',
                    url: 'https://empresa-service.intrare.app/update_access_contractor/' + id + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data:{
                    id_guardhouse_checkin: localStorage.getItem('id_caseta')
                    }
                }
                axios(config)
                    .then(response => {
                        this.dialogContractor = false
                        this.loading = false
                        this.get_access_without_code_by_date()
                        this.errores_guard =this.$t('mensaje_alta_acceso_in')
                        this.head_color = 'green display-1 text--primary'
                        // this.band_gafete = true
                        this.dialog_errores = true
                        setTimeout(this.clear, 3000)
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error.response.data)
                        this.head_color = 'red display-1 text--primary'
                        this.errores_guard = error.response.data.error
                        this.dialog_errores = true
                    })
            },
            qr_is_valid: function(info_invitation){
                console.log(Object.keys(info_invitation).length)
                if (Object.keys(info_invitation).length > 0) {
                    this.valido = true
                    console.log("Valido")
                    this.is_access_in_out_both()
                }
                else{
                    this.valido = false
                    console.log("NO Valido")
                    //     this.$store.commit('snackbar_activate_true')
                    //     this.$store.commit('snackbar_change_color', 'error')
                    //     this.$store.commit('snackbar_change_message', this.$t('mensaje_qr_no_valido'))
                    //     setTimeout(this.clear, 3000)
                    this.clear_without_activate_camera()
                    this.errores_guard =this.$t('mensaje_qr_no_valido')
                    this.head_color = 'red display-1 text--primary'
                    this.dialog_errores = true
                }
            },
            is_access_in_out_both: function(){
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/empresas/accesos/search/' + this.qr_code + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                }
                axios(config)
                    .then(response => {
                        console.log(response.data)
                        this.data_access = response.data
                          if (this.info_invitation.typeInv !== 2) { // Tipo de Invitación Normal
                            if (response.data.length > 0 && response.data[0].fecha_hora_acceso != null && response.data[0].fecha_hora_salida != null){
                              // alert('Ya se completó el acceso con la invitación Correspondiente.')
                              if (this.info_invitation.multiple_accesses === false) {
                                console.log('COMPLETO')
                                this.clear_without_activate_camera()
                                this.head_color = 'orange display-1 text--primary'
                                this.errores_guard =this.$t('mensaje_acceso_completo')
                                this.dialog_errores = true
                              } else {
                                this.entrada = true
                                this.sala_espera = true
                                this.salida = false
                                this.temperature = 0
                                this.datos_coche = ''
                                this.dialog = true
                                console.log('ENTRADA MULTIPLE')
                              }
                            }
                            else{
                              if(response.data.length > 0 ){
                                if (response.data[0].estado === 2) {
                                  this.clear_without_activate_camera()
                                  this.head_color = 'error display-1 text--primary'
                                  this.errores_guard = this.$t('msg_invitation_registered_denied') + response.data[0].comentarios_VE
                                  this.dialog_errores = true
                                  console.log('NEGADO')
                                } else
                                  if (response.data[0].estado === 5) {
                                    this.entrada = true
                                    this.sala_espera = false
                                    this.salida = false
                                    this.dialog = true
                                    console.log('ENTRADA DESDE SALA DE ESPERA')
                                  } else {
                                    this.entrada = false
                                    this.sala_espera = false
                                    this.salida = true
                                    this.dialog = true
                                    console.log('SALIDA')
                                  }
                              }
                              else{
                                this.entrada = true
                                this.sala_espera = true
                                this.salida = false
                                this.temperature = 0
                                this.datos_coche = ''
                                this.dialog = true
                                console.log('ENTRADA')
                              }
                            }
                          } else { // Invitación Recurrente
                            if (response.data.length === 0) {
                              this.entrada = true
                              this.sala_espera = true
                              this.salida = false
                              this.temperature = 0
                              this.datos_coche = ''
                              this.dialog = true
                              console.log('ENTRADA RECURRENTE')
                            } else {
                              if (response.data[0].estado === 1) {
                                this.entrada = false
                                this.sala_espera = false
                                this.salida = true
                                this.dialog = true
                                console.log('SALIDA RECURRENTE', response.data[0])
                              } else
                              if (response.data[0].estado === 5) {
                                this.entrada = true
                                this.sala_espera = false
                                this.salida = false
                                this.dialog = true
                                console.log('ENTRADA RECURRENTE DESDE SALA DE ESPERA', response.data[0])
                              } else {
                                if (response.data[0].estado !== 2) {  //CASO CUANDO SE HA COMPLETADO LA INVITACION RECURRENTE
                                  var fechaLocal = new Date(this.get_current_date_slash())
                                  const readableDate = response.data[0].fecha_hora_acceso.substring(3, 6) + response.data[0].fecha_hora_acceso.substring(0, 2) + response.data[0].fecha_hora_acceso.substring(5, 10)
                                  var fechaAccesoEntrada = new Date(readableDate)
                                  if (fechaAccesoEntrada.getTime() !== fechaLocal.getTime()) {
                                    this.entrada = true
                                    this.sala_espera = true
                                    this.salida = false
                                    this.temperature = 0
                                    this.datos_coche = ''
                                    this.dialog = true
                                    console.log('ENTRADA RECURRENTE')
                                  } else {
                                    if (this.info_invitation.multiple_accesses === false) {
                                      console.log('COMPLETO RECURRENTE')
                                      this.clear_without_activate_camera()
                                      this.head_color = 'orange display-1 text--primary'
                                      this.errores_guard = this.$t('mensaje_acceso_completo')
                                      this.dialog_errores = true
                                    } else {
                                      this.entrada = true
                                      this.sala_espera = true
                                      this.salida = false
                                      this.temperature = 0
                                      this.datos_coche = ''
                                      this.dialog = true
                                      console.log('ENTRADA RECURRENTE MULTIPLE')
                                    }
                                  }
                                } else { // CASO CUANDO LA INVITACION RECURRENTE HA SIDO NEGADA (NOTA: RECORDAR QUE CUANDO SE NIEGA EL ACCESO SOLO ES POR UN DIA)
                                  var fechaLocal3 = new Date(this.get_current_date_slash())
                                  const readableDate = response.data[0].fecha_hora_acceso.substring(3, 6) + response.data[0].fecha_hora_acceso.substring(0, 2) + response.data[0].fecha_hora_acceso.substring(5, 10)
                                  var fechaAccesoEntrada3 = new Date(readableDate)
                                  if (fechaAccesoEntrada3.getTime() !== fechaLocal3.getTime()) {
                                    this.entrada = true
                                    this.sala_espera = true
                                    this.salida = false
                                    this.temperature = 0
                                    this.datos_coche = ''
                                    this.dialog = true
                                    console.log('ENTRADA RECURRENTE')
                                  } else {
                                    this.clear_without_activate_camera()
                                    this.head_color = 'error display-1 text--primary'
                                    this.errores_guard = this.$t('msg_invitation_registered_denied') + response.data[0].comentarios_VE
                                    this.dialog_errores = true
                                    console.log('NEGADO')
                                  }
                                }
                              }
                            }
                          }
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            is_access_contractor_in_out_both: function(){
            const config = {
                method: 'get',
                url: 'https://empresa-service.intrare.app/contractor_access/search/' + this.qr_code + '/',
                headers: {
                'Content-Type': 'application/json',
                'authorization': 'Token ' + store.getters.getToken
                }
            };
            axios(config)
                .then(response => {
                    console.log(response.data)
                    if (response.data.length > 0) {
                    this.data_access_contractor = response.data[0]
                    }
                    if (response.data.length === 0) {
                    this.entrada = true
                    this.sala_espera = true
                    this.dialogContractor = true
                    this.activar_camara = false
                    console.log('ENTRADA CONTRATISTA NINGUN REGISTRO DE ACCESO')
                    } else {
                    if (response.data[0].estado === 1) {
                        this.id_area = response.data[0].id_area
                        this.id_empleado = response.data[0].id_empleado
                        this.empresa = response.data[0].empresa
                        this.notas = response.data[0].notas
                        this.entrada = false
                        this.sala_espera = false
                        this.dialogContractor = true
                        this.activar_camara = false
                        console.log('SALIDA CONTRATISTA', response.data[0])
                    } else
                    if (response.data[0].estado === 5) {
                        this.id_area = response.data[0].id_area
                        this.id_empleado = response.data[0].id_empleado
                        this.empresa = response.data[0].empresa
                        this.notas = response.data[0].notas
                        this.entrada = true
                        this.sala_espera = false
                        this.dialogContractor = true
                        this.activar_camara = false
                        console.log('ENTRADA CONTRATISTA DESDE SALA DE ESPERA', response.data[0])
                    } else {
                        if (response.data[0].estado === 2 || response.data[0].estado === 3) {
                        this.entrada = true
                        this.sala_espera = true
                        this.dialogContractor = true
                        this.activar_camara = false
                        this.data_access_contractor = {
                            'id': 0,
                            'host': '',
                            'guest': '',
                            'url_foto': '',
                            'authorized': false,
                            'pase_salida': false,
                            'count_authorized': 2,
                            'count_pase_salida': 2,
                            'estado': -1,
                            'notas': '',
                            'empresa': '',
                            'f_acceso': '',
                            'company_logo': '',
                            'areaName': ''
                        },
                        console.log('ENTRADA RECURRENTE')
                        } else {
                        if(response.data[0].estado === 0) {
                            this.id_area = response.data[0].id_area
                            this.id_empleado = response.data[0].id_empleado
                            this.empresa = response.data[0].empresa
                            this.notas = response.data[0].notas
                            this.entrada = true
                            this.entrada = true
                            this.sala_espera = false
                            this.dialogContractor = true
                            this.activar_camara = false
                            console.log('ENTRADA CONTRATISTA')
                        }
                        }
                    }
                    }
                })
                .catch(error => {
                    console.log(error)
                })
            },
            create_acceso: function(id_invitacion){
                this.loading = true
                console.log(this.qr_code)
                var qrCode = this.qr_code
                const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/empresas/access/create',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        id_invitacion: id_invitacion,
                        qr_code: this.qr_code,
                        datos_coche: this.datos_coche,
                        temperature: parseFloat(this.temperature, 10),
                        id_guardhouse_checkin: localStorage.getItem('id_caseta')
                    }
                }
                axios(config)
                    .then(response => {
                        this.loading = false
                        // this.$store.commit('snackbar_activate_true')
                        // this.$store.commit('snackbar_change_message', this.$t('mensaje_alta_acceso_in'))
                        // this.dialog = false
                        // setTimeout(this.clear, 3000);
                        // console.log(this.info_invitation)
                        this.get_access_without_code_by_date()
                        this.clear_without_activate_camera()
                        this.errores_guard =this.$t('mensaje_alta_acceso_in')
                        this.head_color = 'green display-1 text--primary'
                        this.band_gafete = true
                        this.dialog_errores = true
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error.response.data)
                        this.clear_without_activate_camera()
                        this.head_color = 'red display-1 text--primary'
                        this.errores_guard = error.response.data.error
                        this.dialog_errores = true
                    })
            },
            enviarSalaEspera () {
                this.loading = true
                console.log(this.qr_code)
                const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/empresas/access/create/waiting_room',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        qr_code: this.qr_code,
                        estado: 5,
                        comentarios_VE: this.comentarios_VE
                    }
                }
                axios(config)
                    .then(response => {
                        this.loading = false
                        // this.$store.commit('snackbar_activate_true')
                        // this.$store.commit('snackbar_change_message', this.$t('mensaje_alta_acceso_in'))
                        // this.dialog = false
                        // setTimeout(this.clear, 3000);
                        // console.log(this.info_invitation)
                        this.clear_without_activate_camera()
                        this.errores_guard = 'Enviado a la Sala de Espera Correctamente'
                        this.head_color = 'green display-1 text--primary'
                        this.band_gafete = true
                        this.dialog_errores = true
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error.response.data)
                        this.clear_without_activate_camera()
                        this.head_color = 'red display-1 text--primary'
                        this.errores_guard = error.response.data.error
                        this.dialog_errores = true
                    })
            },
            update_acceso (pk){
                this.loading = true
                console.log(this.qr_code)
                const config = {
                    method: 'put',
                    url: 'https://empresa-service.intrare.app/empresas/access/update/forExit/' + pk + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        estado: 0,
                        motivo_no_firma: this.motivo_no_firma,
                        comentarios_VE: this.comentarios_VE,
                        id_guardhouse_checkout: localStorage.getItem('id_caseta')
                    }
                }
                axios(config)
                    .then(response => {
                        this.loading = false
                        this.clear_without_activate_camera()
                        this.head_color = 'green display-1 text--primary'
                        this.errores_guard =this.$t('mensaje_alta_acceso_out')
                        this.dialog_errores = true
                        // this.$store.commit('snackbar_activate_true')
                        // this.$store.commit('snackbar_change_message', this.$t('mensaje_alta_acceso_out'))
                        // setTimeout(this.clear, 3000);
                    })
                    .catch(error => {
                        this.loading = false
                        if(error.response.status == 400
                            && typeof error.response.data == "object"
                            && error.response.data)
                            this.errores = error.response.data
                    })

            },
            example: item => item.first_name + ' ' + item.last_name +' - ' + item.email,
            customFilterArea (item, queryText) {
            const textOne = item.nombre.toLowerCase()
            const searchText = queryText.toLowerCase()
            return textOne.indexOf(searchText) > -1
            },
            customFilter (item, queryText) {
            const textOne = item.first_name.toLowerCase()
            const textTwo = item.last_name.toLowerCase()
            const textThree = item.email.toLowerCase()
            const searchText = queryText.toLowerCase()
            return textOne.indexOf(searchText) > -1
                || textTwo.indexOf(searchText) > -1
                || textThree.indexOf(searchText) > -1

            },
            updateAccessforAccess (pk){
                this.loading = true
                console.log(this.qr_code)
                const config = {
                    method: 'put',
                    url: 'https://empresa-service.intrare.app/empresas/access/update/forAccess/' + pk + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        motivo_no_firma: this.motivo_no_firma,
                        comentarios_VE: this.comentarios_VE,
                        id_guardhouse_checkin: localStorage.getItem('id_caseta')
                    }
                }
                axios(config)
                    .then(response => {
                        this.loading = false
                        this.get_access_without_code_by_date()
                        this.clear_without_activate_camera()
                        this.head_color = 'green display-1 text--primary'
                        this.errores_guard =this.$t('mensaje_alta_acceso_in')
                        this.band_gafete = true
                        this.dialog_errores = true
                    })
                    .catch(error => {
                        this.loading = false
                        if(error.response.status == 400
                            && typeof error.response.data == "object"
                            && error.response.data)
                            this.errores = error.response.data
                    })

            },
            updateCount () {
                this.loadingCount = true
                const config2 = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/empresas/accesos/search/' + this.qr_code + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                }
                axios(config2)
                    .then(response2 => {
                        if (this.info_invitation.typeInv !== 2)
                            this.data_access = response2.data
                        else
                          if (response2.data.length > 1) {
                            this.data_access = response2.data
                            console.log('Datos Accesos Count = ', response2.data[0])
                            }
                          else
                            this.data_access = response2.data
                        this.loadingCount = false
                    })
                    .catch(error => {
                        this.loadingCount = false
                        console.log(error)
                    })
            },
            updateCountEntrada () {
                this.loadingCountIn = true
                const config2 = {
                    method: 'get',
                    url:  'https://empresa-service.intrare.app/get_inv/gaurd/' + this.qr_code + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                }
                axios(config2)
                    .then(response2 => {
                        if (this.info_invitation.typeInv !== 2)
                            this.info_invitation = response2.data
                        else
                          if (response2.data.length > 1) {
                            this.info_invitation = response2.data
                            console.log('Datos Invitacion Count = ', response2.data[0])
                            }
                          else
                            this.info_invitation = response2.data
                        this.loadingCountIn = false
                    })
                    .catch(error => {
                        this.loadingCountIn = false
                        console.log(error)
                    })
            },
            notificar_anfitrion_firmar(){
                this.loading = true
                console.log('Avisar al Anfitrión que firme pase de Salida = ', this.data_access[0].id)
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/notifySignExitPass/' + this.data_access[0].id + '/',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                };
                axios(config)
                    .then(response => {
                        this.loading = false
                        this.countDownSign = 30
                        this.countDownSignTimer()
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('msg_notificacion_anfitrion'))
                        const config2 = {
                            method: 'get',
                            url: 'https://empresa-service.intrare.app/empresas/accesos/search/' + this.qr_code + '/',
                            headers: {
                                'Content-Type': 'application/json',
                                'authorization': 'Token ' + store.getters.getToken
                            }
                        }
                        axios(config2)
                            .then(response2 => {
                                console.log(response2.data)
                                if (this.info_invitation.typeInv !== 2)
                                    this.data_access = response2.data
                                else
                                  if (response2.data.length > 1) {
                                    console.log('Datos de acceso despues de notificar al Antitrion = ,', response2.data[0])
                                    this.data_access = response2.data
                                  }
                                  else
                                    this.data_access = response2.data
                            })
                            .catch(error => {
                                console.log(error)
                            })
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error)
                    })
            },
            notificar_anfitrion_acceso(){
                this.loading = true
                console.log('Avisar al Anfitrión que autorize el acceso de su invitado= ', this.info_invitation.id)
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/notifyAuthorizedAccess/' + this.info_invitation.id + '/',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                };
                axios(config)
                    .then(response => {
                        this.loading = false
                        this.countDown = 30
                        this.countDownTimer()
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('msg_notificacion_anfitrion'))
                        const config2 = {
                            method: 'get',
                            url: 'https://empresa-service.intrare.app/get_inv/gaurd/' + this.qr_code + '/',
                            headers: {
                                'Content-Type': 'application/json',
                                'authorization': 'Token ' + store.getters.getToken
                            }
                        }
                        axios(config2)
                            .then(response2 => {
                                console.log(response2.data)
                                if (this.info_invitation.typeInv !== 2)
                                    this.info_invitation = response2.data
                                else
                                  if (response2.data.length > 1) {
                                    console.log('Datos de acceso despues de notificar al Antitrion = ,', response2.data[0])
                                    this.info_invitation = response2.data
                                  }
                                  else
                                    this.info_invitation = response2.data
                            })
                            .catch(error => {
                                console.log(error)
                            })
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error)
                    })
            },
            notificar_anfitrion_acceso_contractor(id){
                this.loading = true
                console.log('Avisar al Anfitrión que autorize el acceso al contratista = ', id)
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/notifyAuthorizedAccessContractor/' + id + '/',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                };
                axios(config)
                    .then(response => {
                        this.loading = false
                        this.countDownAuthorizedAccessContractor = 30
                        this.countDownTimerAccessContractor(id)
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_color', 'success')
                        this.$store.commit('snackbar_change_message', this.$t('msg_notificacion_anfitrion'))
                        setTimeout(this.clear2, 3000)
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error)
                    })
            },
            getRecordAccessContracorById(id) {
            this.loadingCountInAccessContractor = true
            const config = {
                method: 'get',
                url: 'https://empresa-service.intrare.app/contractor_access/' + id,
                headers: {
                'Content-Type': 'application/json',
                'Accept-Language': this.language,
                },
            };
            axios(config)
                .then(ok => {
                    this.loadingCountInAccessContractor = false
                    if (ok.data.length > 0) {
                    this.data_access_contractor = ok.data[0]
                    }
                    console.log('Datos devueltos por Servidor DESPUES DE NOTIFICAR POR SEGUNDA OCASION AL ANFITRION')
                    console.log(this.data_access_contractor)
                    console.log('Id = ', this.data_access_contractor.id)
                })
                .catch(error => {
                    this.loadingCountInAccessContractor = false
                    console.log(error)
                })
            },
            clear_without_activate_camera: function () {
                this.dialog = false
                this.qr_code = ''
                this.entrada = false
                this.salida = false
                this.sala_espera = false
            },
            clear_without_activate_camera2: function () {
                this.dialog = false
                this.entrada = false
                this.salida = false
                this.sala_espera = false
            },
            clear() {
                this.dialog = false
                this.dialogContractor = false
                this.qr_code = ''
                this.entrada = false
                this.sala_espera = false
                this.salida = false
                this.$store.commit('snackbar_activate_false')
                this.$store.commit('snackbar_change_color', 'success')
            },
            clear2() {
                this.$store.commit('snackbar_activate_false')
                this.$store.commit('snackbar_change_color', 'success')
            },
            xOffset: function(pdf, text){
                console.log('Page width =', pdf.internal.pageSize.width/72)
                console.log('text width =', pdf.getStringUnitWidth(text))
                console.log('Font width =', pdf.internal.getFontSize())
                return ((pdf.internal.pageSize.width / 2) - (pdf.getStringUnitWidth(text) * pdf.internal.getFontSize() / 2) / 72.0)
            },
            getImgFromUrl(logo_url, callback) {
                var img = new Image();
                img.src = logo_url;
                img.onload = function () {
                    callback(img);
                };
            },
            download_gafete_original: function(){
                this.loading_gafete = true
                console.log('Datos de la Invitación: ')
                console.log(this.info_invitation)
                // console.log(this.info_invitation)
                const toDataUrl = (url, callback) => {
                    const xhr = new XMLHttpRequest();
                    xhr.onload = () => {
                        const reader = new FileReader();
                        reader.onloadend = () => {
                            callback(reader.result);
                        };
                        reader.readAsDataURL(xhr.response);
                    };
                    xhr.open('GET', url);
                    xhr.responseType = 'blob';
                    xhr.send();
                };

                toDataUrl(this.info_invitation.avatar, (myBase64) => {
                    var pdf = new jsPDF("portrait", "pt", "letter")
                    // Black square with rounded corners
                    pdf.setDrawColor(0)
                    pdf.setFillColor(255, 255, 255)
                    pdf.roundedRect(180, 50, 250, 400, 5, 5, 'FD')
                    pdf.setFontStyle("bold")
                    pdf.text(this.info_invitation.empresa,
                        this.xOffset(pdf, this.info_invitation.empresa),
                        130)
                    pdf.setFontStyle("normal")
                    pdf.text(this.$t('Visitante'),
                        this.xOffset(pdf, this.$t('Visitante')),
                        145)
                    pdf.setFontStyle("bold")
                    pdf.text(this.info_invitation.guestFirstName + ' ' + this.info_invitation.guestLastName,
                        this.xOffset(pdf, this.info_invitation.guestFirstName + ' ' + this.info_invitation.guestLastName) ,
                        160)
                    pdf.setFontStyle("normal")
                    pdf.text(this.$t('Anfitrion'),
                        this.xOffset(pdf, this.$t('Anfitrion')),
                        175)
                    pdf.setFontStyle("bold")
                    pdf.text(this.info_invitation.hostFirstName + ' ' + this.info_invitation.hostLastName,
                        this.xOffset(pdf, this.info_invitation.hostFirstName + ' ' + this.info_invitation.hostLastName),
                        190)
                    pdf.setFontStyle("normal")
                    pdf.text(this.$t('Area'),
                        this.xOffset(pdf, this.$t('Area')),
                        205)
                    pdf.setTextColor(this.info_invitation.areaColor)
                    pdf.setFontStyle("bold")
                    pdf.text(this.info_invitation.areaName.toUpperCase(),
                        this.xOffset(pdf, this.info_invitation.areaName.toUpperCase()),
                        220)
                    pdf.setTextColor('#000000')
                    pdf.text(this.$t('fecha_hora'),
                        this.xOffset(pdf, this.$t('fecha_hora')),
                        235)
                    pdf.setFontStyle("normal")
                    pdf.text(this.info_invitation.dateInv + ' ' + this.info_invitation.timeInv,
                        this.xOffset(pdf, this.info_invitation.dateInv + ' ' +  this.info_invitation.timeInv),
                        250)
                    pdf.setLineWidth(4.0)
                    pdf.setDrawColor(this.info_invitation.areaColor)
                    pdf.setFillColor('#FFFFFF')
                    pdf.roundedRect(212, 257, 186, 186, 5, 5, 'FD')
                    // console.log(myBase64); // myBase64 is the base64 string
                    pdf.addImage(myBase64, 'WEBP', 215, 260, 180, 180);
                    toDataUrl(this.info_invitation.logoEmpresa, (logo_guest) => {
                        pdf.addImage(logo_guest, 'WEBP', 190, 60, 50, 50);
                        this.getImgFromUrl(require('../../assets/intrare_logo.png'), function (logo_system,) {
                            pdf.addImage(logo_system, 'WEBP', 370, 60, 50, 50);
                            pdf.save('gafete.pdf')
                        });
                    });
                    this.loading_gafete = false
                });
            },
            download_gafete: function(){
              console.log('Bandera Acceso sin Codigo = ', this.bandAccessNoCode)
              this.loading_gafete = true
              console.log('Datos de la Invitación: ')
              console.log(this.info_invitation)
              // console.log(this.info_invitation)
              const toDataUrl = (url, callback) => {
                const xhr = new XMLHttpRequest();
                xhr.onload = () => {
                  const reader = new FileReader();
                  reader.onloadend = () => {
                    callback(reader.result);
                  };
                  reader.readAsDataURL(xhr.response);
                };
                xhr.open('GET', url);
                xhr.responseType = 'blob';
                xhr.send();
              };
              var pdf = new jsPDF('l', 'in', [288, 144])
              // Black square with rounded corners
              pdf.setDrawColor(0)
              pdf.setFontSize(9)
              pdf.text(this.$t('fecha_hora_acceso'),
                  2.3,
                  0.4)
              pdf.setLineWidth(0.02)
              pdf.line(2.3, 0.42, 3.7, 0.42)
              pdf.setFontStyle("normal")
              pdf.text(this.getCurrentDateSlash() + ' ' + this.getCurrentTime(), 2.7, 0.6)
              pdf.setFontSize(14)
              // pdf.setFillColor(255, 255, 255)
              // pdf.roundedRect(180, 50, 250, 400, 5, 5, 'FD')
              // pdf.setFontStyle("bold")
              // pdf.text(this.info_invitation.empresa,
              //     this.xOffset(pdf, this.info_invitation.empresa),
              //     130)
              pdf.line(this.xOffset(pdf, this.$t('Visitante').toUpperCase()), 0.92, 2.6, 0.92)
              pdf.setFontStyle("bold")
              pdf.text(this.$t('Visitante').toUpperCase(),
                  this.xOffset(pdf, this.$t('Visitante').toUpperCase()),
                  0.9)
              pdf.setFontSize(16)
              pdf.setFontStyle("normal")
              pdf.text(this.bandAccessNoCode === true ? this.dataAccessNoCode.nombre : this.info_invitation.guestFirstName + ' ' + this.info_invitation.guestLastName,
                  this.xOffset(pdf, this.bandAccessNoCode === true ? this.dataAccessNoCode.nombre : this.info_invitation.guestFirstName + ' ' + this.info_invitation.guestLastName),
                  1.2)
              pdf.line(this.xOffset(pdf, this.$t('Anfitrion').toUpperCase()), 1.47, 2.6, 1.47)
              pdf.setFontSize(14)
              pdf.setFontStyle("bold")
              pdf.text(this.$t('Anfitrion').toUpperCase(),
                  this.xOffset(pdf, this.$t('Anfitrion').toUpperCase()),
                  1.45)
              pdf.setFontSize(16)
              pdf.setFontStyle("normal")
              pdf.text(this.bandAccessNoCode === true ? this.dataAccessNoCode.host : this.info_invitation.hostFirstName + ' ' + this.info_invitation.hostLastName,
                  this.xOffset(pdf, this.bandAccessNoCode === true ? this.dataAccessNoCode.host : this.info_invitation.hostFirstName + ' ' + this.info_invitation.hostLastName),
                  1.70)
              // pdf.setFontStyle("normal")
              // pdf.text(this.$t('Area'),
              //     this.xOffset(pdf, this.$t('Area')),
              //     205)
              // pdf.setTextColor(this.info_invitation.areaColor)
              // pdf.setFontStyle("bold")
              // pdf.text(this.info_invitation.areaName.toUpperCase(),
              //     this.xOffset(pdf, this.info_invitation.areaName.toUpperCase()),
              //     220)
              pdf.setTextColor('#000000')
              // pdf.setLineWidth(4.0)
              // pdf.setDrawColor(this.info_invitation.areaColor)
              // pdf.setFillColor('#FFFFFF')
              // pdf.roundedRect(212, 257, 186, 186, 5, 5, 'FD')
              // console.log(myBase64); // myBase64 is the base64 string
              // pdf.addImage(myBase64, 'WEBP', 215, 260, 180, 180);
              toDataUrl(this.bandAccessNoCode === true ? this.dataAccessNoCode.company_logo : this.info_invitation.logoEmpresa, (logo_guest) => {
                pdf.addImage(logo_guest, 'WEBP', 0.25, 0.25, 0.9, 0.7);
                pdf.save('gafete.pdf')
                this.loading_gafete = false
              });
            },
            getCurrentDateSlash () {
              var today = new Date()
              var aux = ''
              var dd = today.getDate()
              var mm = today.getMonth() + 1
              var yyyy = today.getFullYear()

              if (dd < 10) {
                dd = '0' + dd
              }
              if (mm < 10) {
                mm = '0' + mm
              }
              aux = dd + '-' + mm + '-' + yyyy
              return aux
            },
            getCurrentTime () {
              var today = new Date()
              var aux = ''
              var hh = today.getHours()
              var mm = today.getMinutes()

              if (hh < 10) {
                hh = '0' + hh
              }
              if (mm < 10) {
                mm = '0' + mm
              }
              aux = hh + ':' + mm
              return aux
            },
            showOptions() {
              this.reasons = null
              this.dialogReasons = true
            },
            chooseReason () {
              console.log('Reason Choosen = ', this.reasons)
              this.loading_reason = true
              console.log(this.qr_code)
              const config = {
                method: 'post',
                url: 'https://empresa-service.intrare.app/empresas/access/create_deny_access',
                headers: {
                  'Content-Type': 'application/json',
                  'authorization': 'Token ' + store.getters.getToken
                },
                data: {
                  id_invitacion: this.info_invitation.id,
                  qr_code: this.qr_code,
                  comentarios_VE: this.reasons,
                  estado: 2
                }
              }
              axios(config)
                  .then(response => {
                    this.loading_reason = false
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_message', this.$t('msg_host_notified_correctly'))
                    this.dialogReasons = false
                    setTimeout(this.clear, 3000)
                  })
                  .catch(error => {
                    this.loading_reason = false
                  })
            },
            get_current_date_slash () {
              var today = new Date()
              var dd = today.getDate()
              var mm = today.getMonth() + 1
              var yyyy = today.getFullYear()

              if (dd < 10) {
                dd = '0' + dd
              }
              if (mm < 10) {
                mm = '0' + mm
              }
              today = mm + '/' + dd + '/' + yyyy
              return today
            },
            send () {
              this.loading = true
              const config = {
                method: 'PATCH',
                url: 'https://empresa-service.intrare.app/empresas/health_survey/answered/' + this.idUserByInvitation,
                headers: {
                  'Content-Type': 'application/json'
                }
              }
              axios(config)
                  .then(ok => {
                    this.loading = false
                    this.dialogShowSurvey = false
                    this.dialog_errores = false
                    this.survey = false
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_message', this.$t('survey_success'))
                    setTimeout(this.clear2, 3000)
                    this.copyToClipBoard(this.qr_code)
                  })
                  .catch(error => {
                    this.loading = false
                  })
            }
        }
    }
</script>

<style scoped>
    .error {
        font-weight: bold;
        color: red;
    }

    #datas {
        font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
        border-collapse: collapse;
        width: 100%;
    }

    #datas td, #datas th {
        padding: 8px;
    }

    #datas tr:nth-child(even){background-color: #f2f2f2;}

    #datas tr:hover {background-color: #ddd;}

    #datas th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: #002b48;
        color: white;
    }
</style>
